const asset = (name) => require(`@/assets/whats-gb-pt/${name}`);

export const disclaimerText =
  'Aviso: o whats-gb.app é apenas um site informativo. Não hospedamos arquivos APK, não somos uma fonte oficial do WhatsApp GB, não temos afiliação com WhatsApp Inc. ou empresas relacionadas e não atuamos como site de afiliados.';

export const siteLinks = [
  { label: 'Início', url: '/' },
  { label: 'Download', url: '/download/' },
  { label: 'Atualizar', url: '/como-atualizar-gb-whatsapp/' },
  { label: 'Instalar', url: '/como-instalar-gb-whatsapp/' },
  { label: 'Não funciona', url: '/gb-whatsapp-nao-funciona/' },
  { label: 'Bloqueado', url: '/gb-whatsapp-foi-bloqueado/' },
  { label: 'É seguro?', url: '/gb-whatsapp-e-seguro/' },
  { label: 'Comparativo', url: '/gb-whatsapp-vs-whatsapp/' },
];

export const pages = {
  home: {
    type: 'home',
    title: 'GB WhatsApp Atualizado APK (Última Versão)',
    subtitle:
      'Recursos, atualização, instalação, riscos e informações úteis antes de usar o WhatsApp GB.',
    seoTitle: 'WhatsApp GB Atualizado APK  18.80',
    metaDescription:
      'Download WhatsApp GB  18.80 APK atualizado para Android. Veja recursos, novidades, compatibilidade e como instalar a versão mais recente.',
    keywords: 'WhatsApp GB',
    slug: '/',
    breadcrumb: [{ label: 'Início', url: '/' }],
    heroImage: asset('screen-hero-collage.jpg'),
    cta: { label: 'Baixar GB WhatsApp', url: '/download/' },
    badges: ['Versão  18.80', '80M', 'Android 5.0+', 'Site informativo'],
    intro: [
      '[WhatsApp GB](/) é a versão modificada que muita gente usa por temas, opções extras de privacidade visual e envio de mídia com menos limite. Nesta página você encontra versão de referência ( 18.80, ~80M, Android 5.0+), passos de instalação e o que fazer quando algo dá errado.',
      'O whats-gb.app não hospeda APK — só organiza guias. Daqui você vai para [download](/download/), [instalação](/como-instalar-gb-whatsapp/), [atualização](/como-atualizar-gb-whatsapp/) ou solução de [problemas](/gb-whatsapp-nao-funciona/) conforme sua necessidade.'
    ],
    summaryCards: [
      {
        label: 'Versão de referência',
        value: ' 18.80',
        text: 'Base usada para explicar recursos, instalação, atualização e requisitos.'
      },
      {
        label: 'Tamanho aproximado',
        value: '80M',
        text: 'Reserve espaço extra para download, instalação, cache e backup.'
      },
      {
        label: 'Sistema mínimo',
        value: 'Android 5.0+',
        text: 'A compatibilidade pode variar conforme aparelho, pacote e fonte externa.'
      },
      {
        label: 'Tipo de site',
        value: 'Informativo',
        text: 'Sem hospedagem de APK, sem promessa anti-ban e sem afiliação oficial.'
      }
    ],
    highlightLabel: 'Visão rápida',
    highlightTitle: 'O que você encontra neste guia',
    highlightCards: [
      {
        tag: 'Recursos',
        title: 'Personalização e privacidade',
        text: 'Resumo dos recursos mais procurados, como temas, controles visuais, opções de status e ajustes de atividade.'
      },
      {
        tag: 'Instalação',
        title: 'Passos antes de instalar',
        text: 'Backup, espaço livre, permissão para apps desconhecidos e cuidados para reduzir erros durante o processo.'
      },
      {
        tag: 'Segurança',
        title: 'Riscos explicados sem exagero',
        text: 'Diferenças entre app oficial e modificado, privacidade, origem do APK e possibilidade de bloqueio de conta.'
      },
      {
        tag: 'Soluções',
        title: 'Problemas comuns no Android',
        text: 'Falha ao instalar, verificação travada, app fechando, update com erro e conta temporariamente bloqueada.'
      }
    ],
    toc: [
      'O Que é o GB WhatsApp?',
      'Principais Recursos do GB WhatsApp',
      'Novidades da Última Versão',
      'Como Baixar o GB WhatsApp',
      'Como Instalar o GB WhatsApp',
      'Requisitos do Android',
      'GB WhatsApp vs WhatsApp Oficial',
      'O GB WhatsApp é Seguro?',
      'O GB WhatsApp Pode Ser Banido?',
      'Problemas Comuns e Soluções',
      'Por Que os Usuários Escolhem o GB WhatsApp?',
      'Dicas Para Usar o GB WhatsApp com Segurança',
      'Perguntas Frequentes',
      'Conclusão'
    ],
    sections: [
      {
        title: 'Resumo rápido do WhatsApp GB  18.80',
        heading: false,
        paragraphs: [
          'O WhatsApp GB  18.80 aparece neste site como uma referência para quem pesquisa por APK atualizado, recursos extras e compatibilidade com Android. A página reúne informações importantes em um só lugar para evitar que o usuário precise depender apenas de chamadas de download espalhadas pela internet.',
          'Antes de qualquer ação, vale separar três pontos: o app é modificado, o arquivo não é hospedado aqui e não existe garantia séria de segurança total ou proteção contra bloqueio.'
        ],
        list: [
          'Versão de referência:  18.80',
          'Tamanho aproximado: 80M',
          'Android mínimo: 5.0+',
          'Uso indicado apenas com cautela',
          'Backup recomendado antes de instalar'
        ]
      },
      {
        title: 'O Que é o GB WhatsApp?',
        image: asset('screen-chat-options.jpg'),
        paragraphs: [
          'WhatsApp GB é o nome usado por muitos usuários para se referir a uma versão modificada do WhatsApp. Ela costuma reunir recursos extras, como temas, ajustes de privacidade, envio de mídia com mais controle e opções visuais que não aparecem no aplicativo oficial.',
          'Apesar da popularidade, é importante entender que o GB WhatsApp não é desenvolvido pela WhatsApp Inc. Por isso, ele não recebe o mesmo suporte oficial, pode apresentar instabilidade e pode violar regras da plataforma original.'
        ]
      },
      {
        title: 'Principais Recursos do GB WhatsApp',
        paragraphs: [
          'Entre os recursos mais buscados estão temas personalizados, ocultar status online, esconder confirmação de leitura, enviar arquivos maiores, mudar fontes, bloquear conversas e baixar status de contatos. Esses recursos explicam por que tanta gente pesquisa por Baixar WhatsApp GB.',
          'Mesmo assim, recurso extra não elimina risco. Qualquer app modificado deve ser avaliado com cuidado, principalmente quando envolve mensagens, contatos, fotos e verificações por número de telefone.'
        ],
        list: [
          'Mais opções de aparência e temas',
          'Controles extras de privacidade',
          'Envio de mídia com menos limitações',
          'Opções para ocultar atividades',
          'Ferramentas úteis para conversas e status'
        ]
      },
      {
        title: 'Novidades da Última Versão',
        paragraphs: [
          'A versão  18.80 é apresentada aqui como a versão de referência do site. Ela aparece com tamanho aproximado de 80M e requisito mínimo Android 5.0+. Antes de instalar qualquer arquivo, confira se a versão exibida no local de download corresponde ao que você espera.',
          'Atualizações podem corrigir falhas, melhorar compatibilidade e reduzir problemas de verificação. Porém, também podem mudar permissões, comportamento do app e estabilidade.'
        ]
      },
      {
        title: 'Como Baixar o GB WhatsApp',
        paragraphs: [
          'A página de download deste site foi criada para organizar informações úteis antes do download, como versão, tamanho, requisitos e etapas de instalação. O botão de download é parte do desenho da página e não hospeda diretamente um arquivo APK.',
          'Se você pretende procurar o APK em outro lugar, evite fontes desconhecidas, promessas exageradas e páginas que usem termos como oficial, 100% seguro ou anti-ban garantido. Leia também o guia sobre se o WhatsApp GB é seguro antes de continuar.'
        ],
        cta: { label: 'Ver página de download', url: '/download/' }
      },
      {
        title: 'Checklist antes do download',
        heading: false,
        paragraphs: [
          'Antes de procurar qualquer APK em uma página externa, faça uma verificação simples. Isso ajuda a reduzir erros de instalação, perda de conversas e exposição a arquivos alterados por terceiros.',
          'O ideal é comparar nome, versão, tamanho, permissões solicitadas e comportamento da página de origem. Promessas como oficial, 100% seguro ou anti-ban garantido devem ser tratadas como sinal de alerta.'
        ],
        list: [
          'Confirmar se a versão exibida é a esperada',
          'Fazer backup das conversas importantes',
          'Verificar espaço livre no aparelho',
          'Evitar páginas com anúncios agressivos',
          'Não compartilhar código de verificação'
        ]
      },
      {
        title: 'Como Instalar o GB WhatsApp',
        image: asset('screen-backup-restore.jpg'),
        paragraphs: [
          'A instalação geralmente exige permitir apps de fontes desconhecidas no Android. O caminho pode mudar de acordo com a marca do celular, mas costuma ficar em Configurações, Segurança, Apps ou Instalar apps desconhecidos.',
          'Antes de instalar, faça backup das conversas, confirme espaço disponível, verifique a bateria e entenda que usar uma versão modificada pode trazer riscos de segurança e bloqueio.'
        ],
        cta: { label: 'Ler tutorial de instalação', url: '/como-instalar-gb-whatsapp/' }
      },
      {
        title: 'Antes de atualizar ou reinstalar',
        heading: false,
        paragraphs: [
          'Atualizar por cima de uma versão antiga pode preservar conversas, mas também pode causar erro se o pacote não for compatível. Reinstalar do zero pode resolver falhas, porém aumenta o risco de perder dados quando não há backup.',
          'Se o app já está funcionando, evite trocar de versão sem motivo claro. Se uma atualização for necessária, confira a bateria, a conexão e o backup antes de abrir o APK.'
        ],
        list: [
          'Não atualize sem backup recente',
          'Evite instalar várias versões em sequência',
          'Feche o app antes de iniciar a atualização',
          'Confira se há espaço para restaurar mídia',
          'Leia avisos de erro antes de tentar de novo'
        ],
        cta: { label: 'Ver guia de atualização', url: '/como-atualizar-gb-whatsapp/' }
      },
      {
        title: 'Requisitos do Android',
        image: asset('screen-app-settings.jpg'),
        paragraphs: [
          'Para esta versão de referência, considere Android 5.0+ como requisito mínimo, tamanho aproximado de 80M e uma conexão estável para baixar o arquivo. Também é recomendado manter espaço livre extra para instalação, cache e restauração de backup.',
          'Celulares muito antigos podem instalar o APK, mas apresentar travamentos, notificações atrasadas ou erro de verificação.'
        ]
      },
      {
        title: 'GB WhatsApp vs WhatsApp Oficial',
        image: asset('screen-bubble-options.jpg'),
        paragraphs: [
          'O WhatsApp oficial prioriza suporte, atualizações pela loja, integração com políticas da plataforma e menor risco de bloqueio. O WhatsApp GB prioriza personalização e funções extras, mas depende de fontes externas e não tem suporte oficial.',
          'A melhor escolha depende do seu perfil. Se você precisa de estabilidade e segurança, o oficial tende a ser mais adequado. Se você quer recursos extras e aceita riscos, leia o comparativo completo antes de decidir.'
        ],
        cta: { label: 'Ver comparação completa', url: '/gb-whatsapp-vs-whatsapp/' }
      },
      {
        title: 'Para quem o WhatsApp GB pode fazer sentido?',
        heading: false,
        paragraphs: [
          'O interesse costuma vir de usuários que gostam de personalizar a interface, testar temas, ajustar privacidade visual e explorar recursos que não aparecem no aplicativo oficial. Para esse perfil, o WhatsApp GB pode parecer atraente.',
          'Já para contas profissionais, números importantes, conversas sensíveis ou usuários que precisam de estabilidade, o app oficial tende a ser uma escolha mais prudente. A decisão deve considerar tanto recursos quanto risco.'
        ],
        list: [
          'Pode interessar a quem gosta de testar recursos',
          'Exige mais cuidado com origem do APK',
          'Não é ideal para conta principal sensível',
          'Pode apresentar instabilidade em alguns aparelhos',
          'Deve ser usado com backup frequente'
        ]
      },
      {
        title: 'O GB WhatsApp é Seguro?',
        image: asset('screen-privacy-security.jpg'),
        paragraphs: [
          'Não é correto afirmar que o WhatsApp GB é completamente seguro. Por ser um app modificado, ele pode envolver riscos ligados à privacidade, origem do arquivo, permissões e bloqueio de conta.',
          'Também não é possível garantir que uma versão seja livre de problemas. O melhor caminho é avaliar a fonte, manter backup, evitar dados sensíveis e entender as diferenças entre apps oficiais e modificados.'
        ],
        cta: { label: 'Ler análise de segurança', url: '/gb-whatsapp-e-seguro/' }
      },
      {
        title: 'O GB WhatsApp Pode Ser Banido?',
        image: asset('screen-home-options.jpg'),
        paragraphs: [
          'Sim. O uso de versões modificadas pode levar a bloqueios temporários ou permanentes, dependendo das regras aplicadas pela plataforma oficial. Nenhum site sério deve prometer que o WhatsApp GB é anti-ban garantido.',
          'Se sua conta já recebeu aviso ou bloqueio, pare de insistir em verificações repetidas, leia a mensagem exibida no app e considere voltar ao WhatsApp oficial para reduzir riscos.'
        ],
        cta: { label: 'Entender bloqueios', url: '/gb-whatsapp-foi-bloqueado/' }
      },
      {
        title: 'Problemas Comuns e Soluções',
        image: asset('screen-clear-temp-files.jpg'),
        paragraphs: [
          'Os problemas mais comuns incluem falha na instalação, erro de verificação, app fechando sozinho, mensagens que não chegam, atualização travada e incompatibilidade com o Android.',
          'Muitos casos podem ser reduzidos com backup, limpeza de cache, atualização correta e verificação de conexão. Se o WhatsApp GB não funciona no seu celular, veja o guia específico de solução de problemas.'
        ],
        list: [
          'WhatsApp GB não abre',
          'Erro de verificação por SMS',
          'Falha ao instalar APK',
          'Problemas após atualização',
          'Conta temporariamente bloqueada'
        ],
        subsections: [
          {
            title: 'GB WhatsApp Não Funciona',
            paragraphs: [
              'Quando o GB WhatsApp não abre ou fecha sozinho, comece verificando conexão, espaço livre, cache do app e compatibilidade com o Android.'
            ]
          },
          {
            title: 'Erro de Verificação',
            paragraphs: [
              'Erros de SMS ou chamada podem ocorrer por tentativas repetidas, número digitado incorretamente, conexão instável ou limitação temporária da conta.'
            ]
          },
          {
            title: 'Falha na Instalação',
            paragraphs: [
              'A falha na instalação costuma estar ligada a APK incompleto, falta de espaço, permissão de fontes desconhecidas bloqueada ou conflito com outro pacote.'
            ]
          },
          {
            title: 'Problemas de Atualização',
            paragraphs: [
              'Se o problema começou depois de atualizar, confira backup, versão instalada, cache e compatibilidade antes de tentar reinstalar.'
            ]
          }
        ],
        cta: { label: 'Resolver problemas comuns', url: '/gb-whatsapp-nao-funciona/' }
      },
      {
        title: 'Por Que os Usuários Escolhem o GB WhatsApp?',
        paragraphs: [
          'A principal razão é controle. Muitos usuários querem mais liberdade para mudar a interface, esconder sinais de atividade, organizar conversas e enviar arquivos com menos restrições.',
          'Esse interesse é real, mas precisa vir acompanhado de informação. Um app modificado pode resolver pequenas limitações do dia a dia e, ao mesmo tempo, criar novos riscos.'
        ]
      },
      {
        title: 'Dicas Para Usar o GB WhatsApp com Segurança',
        paragraphs: [
          'Faça backup com frequência, não compartilhe códigos de verificação, desconfie de promessas de proteção total, evite instalar versões de páginas aleatórias e mantenha uma alternativa oficial caso sua conta seja importante.',
          'Se você usa o app para trabalho, família ou documentos importantes, pense duas vezes antes de depender de uma versão modificada.'
        ]
      }
    ],
    faq: [
      {
        q: 'Este site hospeda o APK?',
        a: 'Não. Só informações; o arquivo você obtém em fonte externa.'
      },
      {
        q: 'Qual versão o site usa como referência?',
        a: ' 18.80, ~80M, Android 5.0+. Confira se bate com o APK que você baixou.'
      },
      {
        q: 'Preciso de backup antes de instalar ou atualizar?',
        a: 'Sim — é o jeito mais simples de não perder conversas se a instalação falhar.'
      },
      {
        q: 'GB pode bloquear minha conta?',
        a: 'Pode, temporária ou permanente. Mod tem mais risco que o oficial.'
      },
      {
        q: 'O app não abre depois de update — por onde começo?',
        a: 'Cache, reinício, depois guia de [atualização](/como-atualizar-gb-whatsapp/) e [não funciona](/gb-whatsapp-nao-funciona/).'
      }
    ],
    conclusion:
      'O WhatsApp GB pode ser interessante para quem busca personalização e recursos extras, mas deve ser avaliado com cuidado. Antes de baixar ou instalar, entenda os riscos, confira os requisitos e lembre-se de que este site é apenas informativo.'
  },
  download: {
    type: 'download',
    title: 'Download WhatsApp GB APK  18.80',
    subtitle:
      'Página de informações para quem procura Baixar [WhatsApp GB](/) atualizado. O botão é apenas parte do design e não aponta para um APK hospedado aqui.',
    seoTitle: 'Guia de Download Seguro do GB WhatsApp para Android',
    metaDescription:
      'Saiba como fazer o download seguro do GB WhatsApp para Android. Veja requisitos, instalação, compatibilidade e informações importantes antes de baixar.',
    slug: '/download/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'Download', url: '/download/' }
    ],
    downloadUrl: 'https://file.gbwasa.com/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.876_gw_07_14.apk',
    cta: { label: 'Baixar WhatsApp GB' },
    badges: ['Versão  18.80', '80M', 'Android 5.0+'],
    intro: [
      'Esta página reúne informações sobre o Download WhatsApp GB APK  18.80 para quem quer entender versão, tamanho, requisitos e etapas antes de instalar. O whats-gb.app não hospeda o arquivo APK e não é uma fonte oficial.',
      'Use esta página como guia visual e informativo. Antes de procurar qualquer arquivo em outro local, leia os avisos de segurança, faça backup das conversas e confira se seu aparelho atende aos requisitos.'
    ],
    infoTable: [
      ['Nome', 'WhatsApp GB'],
      ['Versão', ' 18.80'],
      ['Tamanho', '80M'],
      ['Sistema', 'Android 5.0+'],
      ['Preço', 'Gratuito'],
      ['APK hospedado aqui?', 'Não']
    ],
    sections: [
      {
        title: 'Informações da versão',
        paragraphs: [
          'A versão usada neste site é  18.80, com tamanho aproximado de 80M. Essas informações ajudam o usuário a comparar o que vê em páginas externas de download e evitar arquivos com nomes confusos ou promessas exageradas.',
          'Se uma página disser que o arquivo é oficial, totalmente seguro ou impossível de bloquear, desconfie. O WhatsApp GB é modificado e deve ser tratado com cautela.'
        ]
      },
      {
        title: 'Botão de download',
        paragraphs: [
          'O botão abaixo leva ao fluxo de download, seguindo o estilo de páginas APK. Confira as informações da versão antes de continuar.'
        ],
        downloadBox: true
      },
      {
        title: 'Passos de instalação',
        paragraphs: [
          'Faça backup das conversas, permita instalar apps desconhecidos apenas se souber o que está fazendo, abra o arquivo APK baixado de uma fonte externa e siga a instalação do Android.',
          'Depois da instalação, verifique seu número com calma. Se receber erro ou bloqueio, pare e leia os guias de solução de problemas e bloqueio.'
        ],
        list: [
          'Faça backup das conversas',
          'Confira Android 5.0+ e espaço livre',
          'Permita instalação de fontes desconhecidas',
          'Instale o APK',
          'Verifique seu número'
        ]
      }
    ],
    faq: [
      {
        q: 'O botão baixa o APK?',
        a: 'Não. O botão é apenas parte do design da página. O site não hospeda arquivos APK.'
      },
      {
        q: 'Qual é o tamanho do WhatsApp GB  18.80?',
        a: 'A referência desta página é 80M.'
      },
      {
        q: 'Qual Android é necessário?',
        a: 'A referência mínima é Android 5.0+.'
      }
    ],
    conclusion:
      'A página de download organiza as principais informações do WhatsApp GB  18.80, mas não substitui uma avaliação cuidadosa da origem do arquivo. Leia os avisos e evite promessas de segurança total.'
  },
  update: {
    type: 'article',
    title: 'Como atualizar WhatsApp GB no Android',
    subtitle:
      'Passo a passo para instalar por cima da versão antiga, corrigir erros comuns e recuperar conversas quando o update falha.',
    seoTitle: 'Como Atualizar o GB WhatsApp sem Perder Conversas',
    metaDescription:
      'Veja como atualizar o GB WhatsApp para a versão mais recente sem perder suas conversas. Siga o passo a passo e evite erros durante a atualização.',
    slug: '/como-atualizar-gb-whatsapp/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'Como atualizar WhatsApp GB', url: '/como-atualizar-gb-whatsapp/' }
    ],
    heroImage: asset('screen-app-settings.jpg'),
    intro: [
      'Na maioria dos casos, atualizar o WhatsApp GB significa baixar o APK novo e instalar por cima — sem desinstalar. Funciona bem quando o pacote é o mesmo (mesmo nome de app) e você já fez backup. Este guia cobre o fluxo no Android e o que fazer quando aparece "App não instalado", conversas sumidas ou tela travada.',
      'Use a versão  18.80 (~80M, Android 5.0+) como referência. Antes de baixar, confira nome e tamanho na [página de download](/download/). Se nunca instalou GB, comece pelo guia de [instalação](/como-instalar-gb-whatsapp/).'
    ],
    sections: [
      {
        title: 'Quando vale a pena atualizar',
        paragraphs: [
          'Atualize se o app está lento, fechando sozinho, com recursos quebrados ou quando a fonte que você usa publicou correção explícita. Versões paradas por meses costumam dar erro de verificação ou falha ao enviar mídia.',
          'Não atualize no impulso só porque saiu número novo. Se tudo funciona, anotar a versão atual e esperar feedback de outros usuários evita dor de cabeça. Volte ao [início](/) se quiser comparar requisitos e riscos antes.'
        ]
      },
      {
        title: 'Preparação: backup e espaço livre',
        paragraphs: [
          'Abra o WhatsApp GB → três pontos → Configurações → Conversas → Backup → Fazer backup agora. Espere terminar antes de fechar o app. Se usar Google Drive, confira Wi-Fi estável.',
          'Deixe pelo menos 500 MB livres (APK ~80M + instalação + cache). Em Configurações → Armazenamento, veja se o aparelho não está no limite. Backup local também ajuda: copie a pasta WhatsApp do armazenamento interno para outro lugar, se souber onde ela fica no seu modelo.'
        ],
        list: [
          'Backup concluído dentro do app',
          'Bateria acima de 40%',
          'Wi-Fi ligado para download do APK',
          'Versão nova com mesmo pacote do app instalado',
          'Horário automático ativado (ajuda na verificação depois)'
        ]
      },
      {
        title: 'Atualizar por cima — passo a passo',
        paragraphs: [
          '1) Feche o WhatsApp GB (remova dos apps recentes). 2) Baixe o APK da fonte que você já usa — evite trocar de site no meio do processo. 3) Abra o arquivo e toque Instalar. 4) Se pedir permissão, autorize só o app que está instalando (Chrome, Files, etc.). 5) Abra o GB e veja se as conversas carregam.',
          'Em Samsung: Configurações → Biometria e segurança → Instalar apps desconhecidos → escolha o app usado no download. Em Xiaomi: Configurações → Privacidade → Proteção → Instalar apps desconhecidos. Em Motorola: Configurações → Apps → Acesso especial → Instalar apps desconhecidos.'
        ]
      },
      {
        title: 'Erros na instalação do update',
        paragraphs: [
          '"App não instalado" ou "Pacote inválido": APK incompleto (baixe de novo), assinatura diferente (você trocou de mod/clone) ou versão incompatível com seu Android. Apague o arquivo, baixe outra vez e compare o tamanho com ~80M.',
          '"Conflito com pacote existente": normalmente outro WhatsApp modificado instalado. Desinstale só o conflitante depois de backup — ou use o mesmo pacote de sempre. Para lista completa de sintomas, veja [WhatsApp GB não funciona](/gb-whatsapp-nao-funciona/).'
        ]
      },
      {
        title: 'Conversas sumiram depois do update',
        paragraphs: [
          'Primeiro: abra o app e aguarde alguns minutos na tela inicial — restauração local pode demorar. Depois: Configurações → Conversas → Restaurar backup. Escolha o backup mais recente (local ou Google).',
          'Se pedir restauração e falhar, não reinstale em loop. Verifique se o backup existe em Configurações → Conversas → Backup. Sem backup, a atualização por cima raramente recupera histórico. Nesse cenário, reinstalar do zero só repõe conversas se houver backup na nuvem ou no cartão.'
        ]
      },
      {
        title: 'Atualizar ou reinstalar do zero?',
        paragraphs: [
          'Atualizar por cima: mantém dados quando o pacote é compatível — é o caminho padrão. Reinstalar do zero: use quando o app não abre, o pacote mudou ou corrupção de cache não resolve. Sempre backup antes.',
          'Reinstalar = desinstalar → instalar APK novo → verificar número → restaurar backup. Perde conversas locais se não houver backup. Se a conta mostrou aviso de bloqueio, pare e leia [GB WhatsApp foi bloqueado](/gb-whatsapp-foi-bloqueado/) antes de insistir.'
        ]
      },
      {
        title: 'Como conferir se a versão instalou de fato',
        paragraphs: [
          'Configurações → Ajuda → informações do app (ou "Sobre"). Compare número da versão com o APK que baixou. Se continua na build antiga após "instalar", o pacote pode ser incompatível — não é só cache.',
          'Tamanho em Configurações → Apps → WhatsApp GB → Armazenamento também ajuda: update real costuma mudar levemente o uso após abrir o app uma vez. Se nada mudou, repita o download em Wi-Fi.'
        ]
      },
      {
        title: 'App parou de funcionar após atualizar',
        paragraphs: [
          'Sequência rápida: reinicie o celular → Configurações → Apps → WhatsApp GB → Armazenamento → Limpar cache (não "Limpar dados" ainda) → abra de novo. Se persistir, limpe dados só com backup feito.',
          'Confira se a data/hora está automática. Desative VPN temporariamente. Se o problema começou logo após update de versão major, pode ser bug da build — alguns usuários voltam uma versão anterior até sair correção. Compare também com o [guia de segurança](/gb-whatsapp-e-seguro/) se instalou APK de fonte nova.'
        ]
      }
    ],
    faq: [
      {
        q: 'Preciso desinstalar antes de atualizar?',
        a: 'Quase nunca. Desinstalar sem backup apaga conversas locais. Só desinstale se houver conflito de pacote ou corrupção grave.'
      },
      {
        q: 'Posso atualizar com dados móveis?',
        a: 'Sim, mas Wi-Fi reduz chance de APK corrompido. Confira se o download terminou 100%.'
      },
      {
        q: 'Atualizar evita banimento?',
        a: 'Não. Bloqueio está ligado ao uso de mod, não só à versão antiga.'
      },
      {
        q: 'O update apaga mídia recebida?',
        a: 'Não deveria, se a instalação por cima funcionar. Mídia antiga fica no armazenamento até você apagar manualmente.'
      }
    ],
    conclusion:
      'Como atualizar WhatsApp GB resume-se a: backup, APK compatível, instalar por cima e validar conversas. Erro na instalação → baixar de novo; conversas sumidas → restaurar backup; app instável → cache e, se necessário, reinstalar com backup. Volte ao [início](/) para outros guias.'
  },
  install: {
    type: 'article',
    title: 'Como instalar WhatsApp GB no Android',
    subtitle:
      'Do download do APK à verificação do número — com caminhos de menu por marca e respostas para os erros mais comuns.',
    seoTitle: 'Como Instalar o GB WhatsApp no Android',
    metaDescription:
      'Aprenda como instalar o GB WhatsApp no Android passo a passo. Confira os requisitos, permissões necessárias e dicas para concluir a instalação.',
    slug: '/como-instalar-gb-whatsapp/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'Como instalar WhatsApp GB', url: '/como-instalar-gb-whatsapp/' }
    ],
    intro: [
      'Instalar WhatsApp GB no Android é instalar um APK fora da Play Store. O processo leva poucos minutos quando a permissão de "fontes desconhecidas" está certa e o arquivo baixou completo (~80M na versão  18.80).',
      'Este passo a passo assume Android 5.0 ou superior. Detalhes de versão estão na [página de download](/download/). Depois de instalar, use o guia de [atualização](/como-atualizar-gb-whatsapp/) para manter o app em dia.'
    ],
    sections: [
      {
        title: 'O que conferir antes de instalar',
        image: asset('screen-app-settings.jpg'),
        paragraphs: [
          'Espaço livre: reserve pelo menos 500 MB. Conexão: prefira Wi-Fi para não corromper o APK. Chip ativo: o número precisa receber SMS ou ligação na hora da verificação.',
          'Se você já usa WhatsApp oficial no mesmo número, saiba que migrar para GB pode exigir backup e restauração — ou usar outro aparelho/número. Compare opções no [GB vs WhatsApp oficial](/gb-whatsapp-vs-whatsapp/).'
        ],
        list: [
          'Android 5.0+ (referência do site:  18.80)',
          'APK com tamanho próximo de 80M',
          'Backup das conversas (oficial ou GB antigo)',
          'Cartão SIM no aparelho ou eSIM ativo',
          'Código de verificação só para você — nunca compartilhe'
        ]
      },
      {
        title: 'Permitir fontes desconhecidas por marca',
        image: asset('screen-app-settings.jpg'),
        paragraphs: [
          'O Android não deixa instalar APK até você autorizar o app que abrirá o arquivo (Chrome, Samsung Internet, Arquivos, etc.). Autorize só esse app, instale, e depois pode desligar de novo.',
          'Samsung: Configurações → Biometria e segurança → Instalar apps desconhecidos → [seu navegador ou gerenciador]. Xiaomi/MIUI: Configurações → Privacidade → Proteção → Instalar apps desconhecidos. Motorola: Configurações → Apps → Acesso especial → Instalar apps desconhecidos. Pixel: Configurações → Apps → Acesso especial → Instalar apps desconhecidos.'
        ]
      },
      {
        title: 'Instalar o APK na ordem certa',
        paragraphs: [
          '1) Baixe o APK e espere o download terminar. 2) Toque no arquivo (notificação ou pasta Downloads). 3) Instalar → Concluir. 4) Abra o WhatsApp GB. 5) Aceite termos, digite o número com DDD, confirme.',
          'Na primeira abertura, o app pode pedir permissões de contatos, mídia e notificações — normais para mensageiro. Se pedir acessibilidade ou sobrepor outras apps sem motivo claro, desconfie do APK e não continue.'
        ]
      },
      {
        title: 'Verificação do número na prática',
        paragraphs: [
          'Escolha SMS primeiro; ligação se o SMS não chegar em 5–10 minutos. Digite o código de 6 dígitos assim que aparecer — códigos expiram rápido. Não peça código várias vezes seguidas; espere 10 minutos entre tentativas.',
          'SMS atrasado? Confira sinal, desative modo avião, reinicie o aparelho. Se aparecer "número banido" ou contador de horas, o problema pode ser conta — veja [GB bloqueado](/gb-whatsapp-foi-bloqueado/), não é erro de instalação.'
        ]
      },
      {
        title: 'Mensagens de erro na instalação',
        paragraphs: [
          '"App não instalado": APK corrompido, espaço insuficiente ou pacote incompatível. Baixe de novo, libere espaço, reinicie. "Pacote inválido": arquivo truncado — troque de rede ou use cabo.',
          '"Há um conflito com um pacote": já existe outro mod com assinatura diferente. Desinstale o antigo com backup ou instale o mesmo pacote de sempre. Mais cenários no guia [não funciona](/gb-whatsapp-nao-funciona/).'
        ]
      },
      {
        title: 'WhatsApp oficial e GB juntos',
        paragraphs: [
          'Alguns pacotes GB usam nome de pacote diferente do oficial — aí os dois podem coexistir com números distintos. Mesmo pacote = só um por vez no mesmo número.',
          'Migrar do oficial para GB no mesmo número: backup no oficial → instale GB → restaure quando pedir. Migrar do GB para oficial: backup no GB → desinstale GB → instale oficial pela loja → restaure. Sem backup, histórico local se perde.'
        ]
      },
      {
        title: 'Restaurar backup na primeira abertura',
        image: asset('screen-backup-restore.jpg'),
        paragraphs: [
          'Se migrou do oficial, o GB pode detectar backup local e perguntar se quer restaurar. Toque Restaurar e aguarde — em aparelhos com muitas mídias, pode levar 20–40 minutos com tela ligada.',
          'Backup na nuvem pede mesma conta Google e número. Se pulou restauração sem querer: Configurações → Conversas → Restaurar backup (se ainda disponível). Sem backup, histórico anterior não volta.'
        ]
      },
      {
        title: 'Ajustes úteis logo após instalar',
        paragraphs: [
          'Desative economia de bateria agressiva para o GB: Configurações → Bateria → apps em segundo plano → permitir atividade. Isso reduz atraso de notificação.',
          'Faça o primeiro backup em Configurações → Conversas → Backup. Se for testar recursos extras, anote a versão instalada. Dúvidas sobre origem do APK? Leia [WhatsApp GB é seguro?](/gb-whatsapp-e-seguro/) antes de colocar conversas sensíveis.'
        ]
      }
    ],
    faq: [
      {
        q: 'Preciso root?',
        a: 'Não. Instalação padrão de APK funciona sem root na maioria dos aparelhos.'
      },
      {
        q: 'O site fornece o APK?',
        a: 'Não. O whats-gb.app só explica o processo; o arquivo vem de fonte externa escolhida por você.'
      },
      {
        q: 'Instalação falha só no 4G',
        a: 'Download incompleto é comum em rede instável. Use Wi-Fi e confira se o tamanho bate ~80M.'
      },
      {
        q: 'Posso pular a verificação?',
        a: 'Não. Sem código válido o app não ativa a conta neste aparelho.'
      }
    ],
    conclusion:
      'Instalar WhatsApp GB resume-se a: APK íntegro, permissão no app certo, instalar e verificar com calma. Erro na instalação → baixar de novo; SMS não chega → rede e intervalo entre tentativas; conflito → alinhar pacote ou desinstalar versão antiga com backup. [Início](/) · [Download](/download/).'
  },
  notWorking: {
    type: 'article',
    title: 'WhatsApp GB não funciona: o que fazer',
    subtitle:
      'Diagnóstico por sintoma — conexão, crash, verificação, update quebrado e conta limitada — com ordem de tentativas que funciona na prática.',
    seoTitle: 'GB WhatsApp Não Funciona? Veja Como Resolver',
    metaDescription:
      'O GB WhatsApp não funciona? Descubra as causas mais comuns e veja soluções para problemas de instalação, atualização, conexão e abertura do aplicativo.',
    slug: '/gb-whatsapp-nao-funciona/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'WhatsApp GB não funciona', url: '/gb-whatsapp-nao-funciona/' }
    ],
    intro: [
      'Quando o WhatsApp GB não funciona, a causa muda conforme o sintoma: app que nem abre, tela em "Conectando...", mensagens que não saem ou código SMS que não chega. Tratar tudo igual costuma piorar — especialmente se você limpar dados ou reinstalar sem backup.',
      'Use esta ordem: identifique o sintoma → teste a solução leve → só depois reinstale. Se acabou de [atualizar](/como-atualizar-gb-whatsapp/), leia também a seção de problemas pós-update abaixo.'
    ],
    sections: [
      {
        title: 'Identifique o sintoma antes de mexer',
        paragraphs: [
          'Anote o que acontece: ícone some ao tocar? Fica tela branca? Aparece "Conectando..." eternamente? Só mídia não envia? Erro ao verificar número? Cada um tem caminho diferente.',
          'Anote também a versão (Configurações → Ajuda → sobre) e se mudou algo hoje: update, troca de APK, VPN, segundo chip. Isso evita repetir o mesmo teste inútil.'
        ],
        list: [
          'Não abre / fecha na hora → cache, espaço, versão',
          'Conectando infinito → rede, data/hora, VPN',
          'SMS não chega → tentativas, sinal, bloqueio de conta',
          'Parou após update → compatibilidade, restaurar backup',
          'Só notificação atrasa → bateria em segundo plano'
        ]
      },
      {
        title: 'Conexão, data e hora',
        paragraphs: [
          'Teste abrir google.com no mesmo Wi-Fi e no 4G. Se a internet geral falha, o GB não é o culpado. Se só o GB falha, continue aqui.',
          'Ative data e hora automáticas: Configurações → Data e hora → usar horário da rede. Horário errado quebra certificados e deixa o app em "Conectando...". Desligue VPN e proxy temporariamente. Modo avião 30 segundos ligado/desligado costuma resetar a rede.'
        ]
      },
      {
        title: 'App abre e fecha sozinho',
        paragraphs: [
          'Configurações → Apps → WhatsApp GB → Armazenamento → Limpar cache. Abra de novo. Se continuar, reinicie o aparelho antes de "Limpar dados" — limpar dados apaga sessão local; faça backup antes.',
          'Verifique espaço livre (mínimo ~500 MB). Aparelhos no limite travam apps pesados. Se começou após instalar APK de outro site, a build pode ser instável — volte à fonte anterior ou reinstale versão conhecida seguindo [instalação](/como-instalar-gb-whatsapp/).'
        ]
      },
      {
        title: 'Travado em "Conectando..." ou "Inicializando"',
        paragraphs: [
          'Passo 1: cache + reinício. Passo 2: troque Wi-Fi ↔ dados móveis. Passo 3: desative economia de bateria para o GB. Passo 4: aguarde 15 minutos — servidores do WhatsApp oscilam.',
          'Persistindo: desinstale updates do WebView/Android System WebView (Play Store → desinstalar atualizações) e atualize de novo — WebView velho quebra apps híbridos em alguns modelos. Último recurso: reinstalar GB com backup.'
        ]
      },
      {
        title: 'Código SMS ou ligação não chega',
        paragraphs: [
          'Confirme DDD e número. Espere 10 min entre tentativas. Prefira SMS; ligação automática se disponível. Chip precisa estar ativo — eSIM às vezes atrasa SMS internacional.',
          'Muitas tentativas seguidas geram bloqueio temporário de verificação (não é ban permanente). Se a tela mostrar contador ou "temporariamente indisponível", pare e leia [conta bloqueada](/gb-whatsapp-foi-bloqueado/). Nunca envie o código para "suporte" no Telegram.'
        ]
      },
      {
        title: 'Parou depois de atualizar',
        paragraphs: [
          'Volte uma versão se a nova build tem bug reportado. Ou reinstale a mesma versão por cima após backup. Conversas sumidas → Configurações → Conversas → Restaurar backup.',
          'Erro "pacote inválido" no update → APK incompleto; baixe de novo. Guia completo de update em [como atualizar](/como-atualizar-gb-whatsapp/). Se misturou pacotes de mods diferentes, desinstale um deles — assinaturas conflitam.'
        ]
      },
      {
        title: 'Mensagens não saem mas a internet funciona',
        paragraphs: [
          'Confira se só um chat falha ou todos. Um chat: pode ser bloqueio do contato ou número inválido. Todos: data/hora, VPN off, reinício, cache limpo.',
          'Relógio do aparelho errado por 2–3 minutos já impede envio. Em roaming, ative dados móveis + roaming de dados. Se aparecer um relógio ao lado da mensagem, ainda está pendente — não apague o app; espere ou toque para reenviar quando a rede voltar.'
        ]
      },
      {
        title: 'Quando o problema é a conta, não o celular',
        paragraphs: [
          'Mensagem explícita de violação de termos, contador de horas ou "suporte ao cliente" dentro do app = limitação de conta. Reiniciar celular ou limpar cache não resolve.',
          'Nesse caso, aguarde o prazo, migre para WhatsApp oficial ou use outro número. Serviços pagos de "desbloqueio" não têm relação com suporte real. Compare riscos em [GB é seguro?](/gb-whatsapp-e-seguro/) se for reinstalar mod depois.'
        ]
      }
    ],
    faq: [
      {
        q: 'Limpar cache apaga conversas?',
        a: 'Não. Limpar dados sim — e exige login de novo. Backup antes de limpar dados.'
      },
      {
        q: 'Reinstalar sempre resolve?',
        a: 'Só se o problema for app corrompido. Conta bloqueada ou APK errado continuam após reinstalar.'
      },
      {
        q: 'Notificação atrasa mas mensagem chega ao abrir',
        a: 'Quase sempre bateria/segundo plano. Libere o GB nas configurações de economia de energia.'
      },
      {
        q: 'Funciona no Wi-Fi mas não no 4G',
        a: 'Operadora pode bloquear ou limitar. Teste APN padrão ou contate a operadora; também teste outro chip.'
      }
    ],
    conclusion:
      'WhatsApp GB não funciona pede diagnóstico: rede e horário primeiro, cache depois, reinstalar por último — sempre com backup. SMS e bloqueio são tema de conta, não de "conserto mágico" no Android. Mais contexto no [início](/) e na [página de download](/download/).'
  },
  banned: {
    type: 'article',
    title: 'WhatsApp GB foi bloqueado: o que fazer agora',
    subtitle:
      'Como ler a mensagem na tela, o que tentar no bloqueio temporário e quando migrar para o app oficial.',
    seoTitle: 'GB WhatsApp Foi Bloqueado? O Que Fazer',
    metaDescription:
      'O GB WhatsApp foi bloqueado? Entenda os possíveis motivos, veja como resolver o problema e saiba como reduzir o risco de novos bloqueios.',
    slug: '/gb-whatsapp-foi-bloqueado/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'WhatsApp GB foi bloqueado', url: '/gb-whatsapp-foi-bloqueado/' }
    ],
    intro: [
      'Tela de "conta banida", contador de horas ou pedido para usar "WhatsApp oficial" significa limitação na conta — não bug comum de instalação. A primeira ação é ler o texto exato e parar de ficar pedindo código SMS em loop.',
      'Apps modificados têm risco maior de bloqueio que o oficial. Isso não significa que todo erro de SMS é ban; compare sintomas no guia [não funciona](/gb-whatsapp-nao-funciona/) se ainda não tiver certeza.'
    ],
    sections: [
      {
        title: 'Temporário ou permanente: leia a tela',
        paragraphs: [
          'Temporário: mostra prazo (horas/dias) ou "tente novamente depois". Permanente: diz que a conta não pode mais usar WhatsApp ou manda falar com suporte oficial sem prazo.',
          'Tire print da mensagem com data. Anote se apareceu logo após instalar GB, após update ou após enviar muitas mensagens. Isso ajuda a decidir próximo passo — não compartilhe print com "serviços de desbloqueio" pagos.'
        ]
      },
      {
        title: 'Primeiras 24 horas no bloqueio temporário',
        paragraphs: [
          'Não fique verificando número a cada 5 minutos — isso estende limitação. Aguarde o horário indicado. Desinstale GB se quiser usar o oficial no mesmo número enquanto espera.',
          'Instale WhatsApp oficial pela Play Store, verifique o número, restaure backup se tiver. Quando o prazo acabar, você decide se volta ao GB (com risco) ou fica no oficial. Detalhes de migração em [instalação](/como-instalar-gb-whatsapp/).'
        ]
      },
      {
        title: 'Motivos que aparecem com frequência',
        paragraphs: [
          'Uso de cliente modificado (GB e similares). Envio em massa, grupos novos em sequência, links suspeitos reportados. Várias tentativas de verificação seguidas. Denúncia de contatos.',
          'Versão "anti-ban" no nome do APK não elimina risco — é marketing. Trocar de versão GB após bloqueio sem mudar comportamento costuma repetir o problema.'
        ]
      },
      {
        title: 'O que piora a situação',
        paragraphs: [
          'Pedir SMS dezenas de vezes. Instalar vários mods no mesmo número alternando. Pagar "desbloqueio instantâneo". Usar apps que pedem código de verificação "para ativar recurso".',
          'Automação (bots de resposta em massa, ferramentas de disparo) no GB aumenta muito a chance de flag. Se usa número de trabalho, oficial costuma ser menos dor de cabeça — veja [comparativo](/gb-whatsapp-vs-whatsapp/).'
        ]
      },
      {
        title: 'Voltar ao WhatsApp oficial sem perder tudo',
        paragraphs: [
          'Com backup recente: desinstale GB → instale oficial → verifique → restaurar backup na nuvem ou local. Backup no GB: Configurações → Conversas → Backup antes de desinstalar.',
          'Sem backup, histórico local some ao desinstalar — mídia antiga pode ainda estar na pasta WhatsApp/Media se não apagou. Chats arquivados no Google Drive dependem do backup ter rodado.'
        ]
      },
      {
        title: 'Bloqueio permanente: expectativa realista',
        paragraphs: [
          'Conta permanente geralmente não mostra contador — só aviso de violação. Recurso oficial, quando disponível, fica no app da Play Store ("Suporte" ou formulário da Meta). Resposta pode levar dias ou não reverter.',
          'Número novo + WhatsApp oficial é o caminho prático para quem precisa voltar a usar a plataforma. Conteúdo antigo só volta se existia backup na nuvem vinculado à conta Google, não ao chip em si.'
        ]
      },
      {
        title: 'Serviços pagos de "desbloqueio"',
        paragraphs: [
          'Nenhum site externo controla banimento do WhatsApp. Cobrança por "liberação em 1 hora" é, na prática, golpe ou instrução genérica (esperar, reinstalar oficial).',
          'Canal oficial de contestação, quando existe, fica dentro do app oficial ou formulário da Meta — não via Telegram de terceiros. Desconfie de quem pede pagamento em PIX para "desbanir".'
        ]
      },
      {
        title: 'Reduzir chance de novo bloqueio se voltar ao GB',
        paragraphs: [
          'Use número secundário para teste, não conta principal de trabalho. Evite broadcast agressivo e plugins extras. Mantenha mesma fonte de APK e [atualize](/como-atualizar-gb-whatsapp/) só quando necessário.',
          'Leia [WhatsApp GB é seguro?](/gb-whatsapp-e-seguro/) sobre origem do arquivo — APK adulterado soma risco técnico além de bloqueio. Aceite que mod sempre pode parar de funcionar de um dia para o outro.'
        ]
      }
    ],
    faq: [
      {
        q: 'Bloqueio temporário some sozinho?',
        a: 'Na maioria dos casos, após o prazo mostrado na tela. Até lá, evite novas verificações.'
      },
      {
        q: 'Posso usar o mesmo número no oficial durante o ban?',
        a: 'Em bloqueio temporário, muitas pessoas migram pro oficial no mesmo número. Permanente pode impedir — a tela informa.'
      },
      {
        q: 'Trocar versão GB desbloqueia?',
        a: 'Não. Limitação é da conta, não só do APK instalado.'
      },
      {
        q: 'GB promete anti-ban. É real?',
        a: 'Não há garantia confiável. Nome no APK não muda política da plataforma.'
      }
    ],
    conclusion:
      'WhatsApp GB foi bloqueado: leia a mensagem, espere se for temporário, migre pro oficial se precisar do número agora, ignore "desbloqueio" pago. Mod continua arriscado mesmo depois do prazo. [Início](/) · [Segurança](/gb-whatsapp-e-seguro/) · [Download](/download/).'
  },
  safe: {
    type: 'article',
    title: 'WhatsApp GB é seguro?',
    subtitle:
      'O que dá para verificar antes de instalar: origem do APK, permissões estranhas e sinais de arquivo alterado.',
    seoTitle: 'GB WhatsApp é Seguro? Riscos e Cuidados',
    metaDescription:
      'GB WhatsApp é seguro? Conheça os principais riscos, questões de privacidade, segurança e as diferenças em relação ao WhatsApp oficial.',
    slug: '/gb-whatsapp-e-seguro/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'WhatsApp GB é seguro?', url: '/gb-whatsapp-e-seguro/' }
    ],
    heroImage: asset('screen-privacy-security.jpg'),
    intro: [
      'Ninguém consegue garantir que um WhatsApp GB baixado na internet é 100% seguro — porque não vem da Play Store e cada site empacota o APK do seu jeito. O que dá para fazer é checar origem, permissões e comportamento antes de colocar conversas reais.',
      'Este texto não diz "instale" ou "não instale". Lista o que olhar na prática. Para diferença de recursos, veja [GB vs WhatsApp](/gb-whatsapp-vs-whatsapp/); se já instalou e deu erro, [não funciona](/gb-whatsapp-nao-funciona/).'
    ],
    sections: [
      {
        title: 'O que "seguro" significa aqui',
        paragraphs: [
          'Segurança técnica: o APK não traz código malicioso extra. Privacidade: suas mensagens não vazam por configuração absurda. Conta: você aceita risco de bloqueio por usar mod.',
          'GB pode ser "ok" num aparelho secundário e arriscado demais no celular do trabalho. A pergunta útil é: quanto prejuízo se der problema — não se existe risco zero.'
        ]
      },
      {
        title: 'Origem do APK: o ponto que mais importa',
        paragraphs: [
          'Mesmo nome "WhatsApp GB" aparece em dezenas de sites. Arquivos diferentes, tamanhos diferentes, histórico desconhecido. Prefira fonte que você já usou sem incidente — trocar de site "porque está mais novo" aumenta surpresa.',
          'Desconfie de: página cheia de pop-up, botão falso de Play Store, pedido de pagamento para "ativar", ou APK muito menor/maior que ~80M na versão  18.80. Confira dados na [página de download](/download/) antes de comparar.'
        ]
      },
      {
        title: 'Permissões que merecem pausa',
        paragraphs: [
          'Normal: contatos, armazenamento, câmera, microfone, notificações. Estranho sem explicação: acessibilidade total, sobrepor tela, instalar apps, administrador do dispositivo, SMS além da verificação.',
          'Android 6+: permissões aparecem na instalação e depois em Configurações → Apps → WhatsApp GB → Permissões. Revogue o que não faz sentido. Se o app pede de novo de forma agressiva, pare.'
        ]
      },
      {
        title: 'Privacidade visual ≠ dados protegidos',
        paragraphs: [
          'Recursos "esconder online", "visto por último" ou "digitando..." mudam o que contatos veem — não criptografam de forma diferente do fluxo normal do WhatsApp modificado.',
          'Conversas sensíveis (documentos, saúde, financeiro) num mod de origem duvidosa = risco concentrado. Oficial não elimina todos os problemas, mas tem cadeia de distribuição conhecida.'
        ],
        image: asset('screen-chat-options.jpg')
      },
      {
        title: 'Sinais de APK problemático depois de instalar',
        paragraphs: [
          'Bateria drenando rápido sem uso. Dados móveis altos com app fechado. Anúncios fullscreen dentro do chat. Pedido de login Google/Facebook estranho. Contatos recebendo spam seu sem você enviar.',
          'Desinstale, troque senhas de contas ligadas ao aparelho se necessário, rode antivírus do Play Protect. Se conta foi limitada, leia [bloqueado](/gb-whatsapp-foi-bloqueado/).'
        ]
      },
      {
        title: 'Checklist rápido antes de instalar',
        paragraphs: [
          'Tamanho e versão batem com o esperado. Site sem pressão de "última vaga". Backup feito no app anterior. Número importante? considere oficial. Permissões lidas. Fonte desconhecida só no app instalador, desligada depois.',
          'Primeira instalação: teste com número secundário se tiver chip extra. Passo a passo em [como instalar](/como-instalar-gb-whatsapp/).'
        ],
        list: [
          'APK ~80M na ref.  18.80',
          'Mesma fonte de sempre ou referência confiável',
          'Backup concluído',
          'Permissões revisadas após abrir',
          'Plano B: WhatsApp oficial instalável'
        ]
      },
      {
        title: 'Usar chip secundário para testar',
        paragraphs: [
          'Chip pré-pago barato ou eSIM secundário deixa testar GB sem arriscar número principal. Instale, use uma semana, observe bateria, permissões e estabilidade antes de migrar conta importante.',
          'Depois do teste, desinstale ou mantenha em aparelho reserva. Não ative o mesmo número em dois aparelhos com mods diferentes ao mesmo tempo — conflito de sessão gera logout forçado.'
        ]
      },
      {
        title: 'GB ou oficial: critério prático',
        paragraphs: [
          'Fique no oficial se: conta de trabalho, clientes, grupos grandes, depende de backup Google automático, não quer lidar com update manual de APK.',
          'GB entra em cena se: quer tema/recursos extras, aceita update manual, usa número pessoal secundário, entende bloqueio. Compare lado a lado no [comparativo](/gb-whatsapp-vs-whatsapp/). Depois de instalar, [atualize](/como-atualizar-gb-whatsapp/) só de fonte que confia.'
        ]
      }
    ],
    faq: [
      {
        q: 'Play Protect alertou no APK. Ignoro?',
        a: 'Mods quase sempre disparam alerta por assinatura não oficial. Alerta + fonte desconhecida = pare. Alerta + fonte que você usa há tempo = avalie, mas não é garantia.'
      },
      {
        q: 'GB lê minhas conversas a mais que o oficial?',
        a: 'Tecnicamente um mod pode alterar comportamento. Sem auditoria independente, ninguém prova "não lê". Por isso origem importa.'
      },
      {
        q: 'VPN deixa mais seguro?',
        a: 'VPN não valida APK. Só muda rede; pode até atrapalhar verificação.'
      },
      {
        q: 'Versão mais nova é mais segura?',
        a: 'Só se vier da mesma fonte confiável. Build nova de site aleatório pode ser pior.'
      }
    ],
    conclusion:
      'WhatsApp GB é seguro o suficiente só depois que você valida origem, permissões e impacto se der bloqueio ou arquivo ruim. Não existe mod certificado. Use número secundário para testar, backup sempre, oficial para conta crítica. [Início](/) · [Download](/download/).'
  },
  compare: {
    type: 'article',
    title: 'WhatsApp GB vs WhatsApp: diferenças na prática',
    subtitle:
      'O que muda no uso diário — recursos, update, bloqueio e manutenção — para decidir qual faz sentido no seu caso.',
    seoTitle: 'GB WhatsApp vs WhatsApp: Qual é a Diferença?',
    metaDescription:
      'Compare GB WhatsApp e WhatsApp lado a lado. Veja as diferenças em recursos, privacidade, personalização, atualizações e compatibilidade.',
    slug: '/gb-whatsapp-vs-whatsapp/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'WhatsApp GB vs WhatsApp', url: '/gb-whatsapp-vs-whatsapp/' }
    ],
    intro: [
      'A diferença entre WhatsApp GB e WhatsApp oficial não é só "mais tema". É update pela loja vs APK manual, risco de bloqueio, backup automático e quanto tempo você aceita gastar mantendo o app.',
      'Tabela abaixo resume; seções seguintes entram no detalhe do dia a dia. Instalação do GB: [guia](/como-instalar-gb-whatsapp/). Riscos de APK: [é seguro?](/gb-whatsapp-e-seguro/).'
    ],
    compareTable: [
      ['Critério', 'WhatsApp oficial', 'WhatsApp GB'],
      ['Origem', 'Play Store / App Store', 'APK de site externo'],
      ['Atualizações', 'Automáticas', 'Manual (APK externo)'],
      ['Personalização', 'Limitada', 'Temas, fontes, extras'],
      ['Risco de bloqueio', 'Menor', 'Maior'],
      ['Suporte', 'Central oficial', 'Comunidade / nenhum']
    ],
    sections: [
      {
        title: 'Recursos que mudam no dia a dia',
        paragraphs: [
          'GB costuma trazer: temas, mudar ícone, enviar arquivo maior que o limite oficial (varia por versão), esconder "online", anti-revoke em alguns builds, agendar mensagem em alguns forks.',
          'Oficial traz: canais, comunidades estáveis, backup Google integrado, chamada de vídeo com menos surpresa, compatibilidade com Wear OS e desktop oficial sem gambiarra.'
        ]
      },
      {
        title: 'Privacidade: o que muda de verdade',
        paragraphs: [
          'GB deixa você controlar o que contatos veem (visto, online, digitando). Isso não impede bloqueio nem prova que o APK é limpo.',
          'Oficial tem opções oficiais de privacidade (último visto, foto, grupos) — menos "hack", mais previsível. Detalhes técnicos em [GB é seguro?](/gb-whatsapp-e-seguro/).'
        ]
      },
      {
        title: 'Personalização e manutenção',
        paragraphs: [
          'GB: você troca tema quando quer, mas cada update pode resetar preferência ou quebrar tema de terceiros. Guardar APK antigo "que funcionava" é hábito comum.',
          'Oficial: aparência padrão, porém update noturno automático e menos trabalho. Quem não gosta de mexer em APK quase sempre fica no oficial.'
        ]
      },
      {
        title: 'Prós do GB na prática',
        paragraphs: [
          'Interface do jeito que você quer sem esperar Meta. Alguns limites de mídia mais folgados. Recursos experimentais antes (ou em vez) do oficial.',
          'Útil em aparelho secundário ou conta pessoal onde bloqueio temporário não derruba trabalho. Info de versão na [página de download](/download/).'
        ]
      },
      {
        title: 'Contras que aparecem depois',
        paragraphs: [
          'Update manual, APK de fonte incerta, bloqueio de conta, incompatibilidade após update Android. Dois mods no mesmo aparelho = conflito de pacote.',
          'Suporte zero: deu erro, você same [não funciona](/gb-whatsapp-nao-funciona/) ou fórum. Oficial tem fluxo de ajuda (limitado, mas existe).'
        ]
      },
      {
        title: 'Quem costuma ficar no oficial',
        paragraphs: [
          'Profissionais com clientes no WhatsApp, lojas com catálogo, quem usa WhatsApp Business integrado, pais que precisam de estabilidade, quem não quer lembrar de baixar APK.',
          'Se backup automático e "sempre funciona" valem mais que tema escuro custom, oficial ganha sem drama.'
        ]
      },
      {
        title: 'Updates: o trabalho que ninguém conta',
        paragraphs: [
          'Oficial: update de madrugada, você nem vê. GB: você procura APK, compara tamanho, instala por cima, revalida conversas. Esquecer update por 3–4 meses = bugs de verificação ou incompatibilidade com Android novo.',
          'Quem não quer esse ciclo fica no oficial. Quem aceita, guarda link da fonte e anota versão que funcionou — facilita [rollback](/como-atualizar-gb-whatsapp/) se build nova falhar.'
        ]
      },
      {
        title: 'Quem aceita usar o GB',
        paragraphs: [
          'Quem curte personalizar, testa mod em chip secundário, aceita perder conta secundária se bloquear, tem paciência para backup manual e [instalar](/como-instalar-gb-whatsapp/) de fonte fixa.',
          'Não é "melhor" — é trade-off consciente. Muita gente usa oficial no trabalho e GB no pessoal, em aparelhos ou números separados.'
        ]
      }
    ],
    faq: [
      {
        q: 'Posso ter os dois no mesmo celular?',
        a: 'Só se forem pacotes diferentes (dois ícones). Mesmo pacote = um ou outro. Dois números = dois chips ou eSIM.'
      },
      {
        q: 'GB tem recurso X do oficial?',
        a: 'Varia por versão e fork. Canais oficiais recentes podem faltar ou chegar tarde no GB.'
      },
      {
        q: 'Migrar de GB para oficial perde chat?',
        a: 'Não, se backup Google/local existir antes de desinstalar o GB.'
      },
      {
        q: 'Qual gasta mais bateria?',
        a: 'Depende da versão GB e de economia de energia mal configurada. Oficial tende a ser mais previsível.'
      }
    ],
    conclusion:
      'WhatsApp GB vs WhatsApp: GB troca trabalho manual e risco por customização; oficial troca extras por loja e estabilidade. Escolha pelo número que vai usar, não pelo hype. [Início](/) · [Download](/download/) · [Instalar GB](/como-instalar-gb-whatsapp/).'
  },
  privacy: {
    type: 'legal',
    title: 'Política de Privacidade',
    seoTitle: 'Política de Privacidade',
    metaDescription:
      'Política de privacidade do whats-gb.app: site informativo sobre WhatsApp GB, dados básicos, cookies e avisos importantes.',
    slug: '/privacy-policy/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'Política de Privacidade', url: '/privacy-policy/' }
    ],
    intro: [
      'Esta Política de Privacidade explica, de forma simples, como o whats-gb.app trata informações relacionadas à navegação no site. Somos um site informativo sobre WhatsApp GB e não hospedamos arquivos APK.'
    ],
    sections: [
      {
        title: 'Informações que podemos coletar',
        paragraphs: [
          'Podemos coletar dados técnicos básicos, como páginas acessadas, tipo de navegador, dispositivo e informações agregadas de navegação para melhorar o conteúdo.',
          'Se você entrar em contato conosco, poderemos usar as informações fornecidas apenas para responder sua mensagem.'
        ]
      },
      {
        title: 'Como usamos essas informações',
        paragraphs: [
          'Usamos dados de navegação para entender quais guias são mais úteis, corrigir problemas técnicos e melhorar a experiência do usuário.',
          'Não vendemos dados pessoais e não atuamos como site de afiliados.'
        ]
      },
      {
        title: 'Cookies',
        paragraphs: [
          'Cookies podem ser usados para análise de tráfego e funcionamento básico do site. Você pode bloquear cookies nas configurações do navegador.'
        ]
      },
      {
        title: 'Links externos',
        paragraphs: [
          'O site pode mencionar recursos ou páginas externas. Não controlamos políticas de privacidade, segurança ou conteúdo de terceiros.'
        ]
      },
      {
        title: 'Atualizações desta política',
        paragraphs: [
          'Esta página pode ser atualizada para refletir mudanças no site. A versão publicada aqui é a referência atual.'
        ]
      }
    ],
    faq: [
      {
        q: 'O site hospeda APK?',
        a: 'Não. O site é apenas informativo.'
      },
      {
        q: 'O site é afiliado ao WhatsApp?',
        a: 'Não. Não temos relação com WhatsApp Inc. ou empresas relacionadas.'
      },
      {
        q: 'Vocês vendem dados?',
        a: 'Não vendemos dados pessoais.'
      }
    ],
    conclusion:
      'Nosso objetivo é oferecer conteúdo claro sobre WhatsApp GB com transparência sobre coleta básica de dados e sem hospedagem de APK.'
  },
  about: {
    type: 'legal',
    title: 'Sobre nós',
    seoTitle: 'Sobre o whats-gb.app',
    metaDescription:
      'Conheça o whats-gb.app, um site informativo sobre WhatsApp GB, instalação, atualização, riscos e guias úteis.',
    slug: '/about-us/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'Sobre nós', url: '/about-us/' }
    ],
    intro: [
      'O whats-gb.app é um site informativo criado para explicar temas relacionados ao WhatsApp GB de forma clara, útil e responsável.'
    ],
    sections: [
      {
        title: 'O que publicamos',
        paragraphs: [
          'Publicamos guias, tutoriais, comparativos, respostas a dúvidas comuns e informações gerais sobre instalação, atualização, segurança e problemas do WhatsApp GB.',
          'Nosso conteúdo é escrito para usuários reais, com linguagem simples e sem promessas exageradas.'
        ]
      },
      {
        title: 'O que não fazemos',
        paragraphs: [
          'Não hospedamos APK, não somos fonte oficial, não vendemos downloads e não atuamos como site de afiliados.',
          'Também não prometemos que o WhatsApp GB seja totalmente seguro, oficial ou livre de bloqueios.'
        ]
      },
      {
        title: 'Nosso compromisso',
        paragraphs: [
          'Buscamos apresentar benefícios e riscos de forma equilibrada, ajudando o usuário a tomar decisões com mais informação.',
          'Quando houver dúvida, preferimos uma orientação cautelosa.'
        ]
      }
    ],
    faq: [
      {
        q: 'O whats-gb.app é oficial?',
        a: 'Não. O site não é oficial e não tem afiliação com WhatsApp Inc.'
      },
      {
        q: 'Vocês oferecem APK?',
        a: 'Não. O site não hospeda APK.'
      },
      {
        q: 'O conteúdo é promocional?',
        a: 'Não. O foco é informativo.'
      }
    ],
    conclusion:
      'O whats-gb.app existe para organizar informações úteis sobre WhatsApp GB com clareza, cautela e transparência.'
  },
  disclaimer: {
    type: 'legal',
    title: 'Disclaimer',
    seoTitle: 'Disclaimer do whats-gb.app',
    metaDescription:
      'Leia o disclaimer do whats-gb.app: site informativo sobre WhatsApp GB, sem APK hospedado, sem afiliação oficial e sem promessas.',
    slug: '/disclaimer/',
    breadcrumb: [
      { label: 'Início', url: '/' },
      { label: 'Disclaimer', url: '/disclaimer/' }
    ],
    intro: [
      'Este disclaimer esclarece o papel do whats-gb.app. O site existe apenas para publicar conteúdo informativo sobre WhatsApp GB, incluindo guias, tutoriais, comparações e explicações de risco.'
    ],
    sections: [
      {
        title: 'Sem hospedagem de APK',
        paragraphs: [
          'O whats-gb.app não hospeda arquivos APK diretamente. Qualquer decisão de baixar arquivos em páginas externas é responsabilidade do usuário.'
        ]
      },
      {
        title: 'Sem afiliação oficial',
        paragraphs: [
          'Não somos afiliados à WhatsApp Inc., Meta Platforms, GB WhatsApp ou qualquer empresa relacionada. Nomes citados pertencem aos respectivos proprietários.'
        ]
      },
      {
        title: 'Sem promessa de segurança',
        paragraphs: [
          'Não afirmamos que o WhatsApp GB seja totalmente seguro, livre de riscos ou livre de bloqueios. Apps modificados podem envolver privacidade, estabilidade e risco de conta.'
        ]
      },
      {
        title: 'Conteúdo informativo',
        paragraphs: [
          'O conteúdo é produzido para fins informativos e educativos. Não substitui recomendações oficiais, termos de serviço ou avaliação técnica independente.'
        ]
      }
    ],
    faq: [
      {
        q: 'O site recomenda instalar WhatsApp GB?',
        a: 'O site informa benefícios e riscos. A decisão é do usuário.'
      },
      {
        q: 'Vocês garantem que não haverá banimento?',
        a: 'Não. Nenhuma garantia de anti-ban é oferecida.'
      },
      {
        q: 'O site é afiliado?',
        a: 'Não. Não somos site de afiliados.'
      }
    ],
    conclusion:
      'Use o conteúdo do whats-gb.app como referência informativa e mantenha cautela ao lidar com aplicativos modificados.'
  }
};

export const pageOrder = [
  'home',
  'download',
  'update',
  'install',
  'notWorking',
  'banned',
  'safe',
  'compare',
  'privacy',
  'about',
  'disclaimer'
];

export const metaByKey = pageOrder.reduce((acc, key) => {
  const page = pages[key];
  acc[key] = {
    appname: 'WhatsApp GB',
    title: page.seoTitle,
    keywords: page.keywords || '',
    description: page.metaDescription,
    link: [
      {
        rel: 'canonical',
        href: `https://whats-gb.app${page.slug}`
      }
    ]
  };
  return acc;
}, {});
